/**
 * `/sign-in/sent` — confirmation that a magic-link email was dispatched.
 */

import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthShell } from '../components/layout/AuthShell';
import { useSession } from '../hooks/useSession';

interface NavState {
  email?: string;
}

export function SignInSentPage() {
  const state = (useLocation().state as NavState | null) ?? {};
  const { refresh } = useSession();

  useEffect(() => {
    const id = setInterval(() => {
      void refresh();
    }, 5000);
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <AuthShell topRight={<Link to="/sign-in">Use a different email</Link>}>
      <div className="auth-card">
        <div className="success-mark" aria-hidden>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 7l9 6 9-6M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7M3 7l9 6 9-6"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="auth-eyebrow">
          <span className="num">05·b</span> · Check your inbox
        </div>
        <h1 className="auth-title">
          Check your <em>inbox</em>.
        </h1>
        <p className="auth-sub">
          {state.email ? (
            <>
              If we recognize <strong style={{ color: 'var(--fg-1)' }}>{state.email}</strong>, you'll receive a link shortly — either a sign-in link or, if you're still on the waitlist, a status link. Either way, it expires in 15 minutes.
            </>
          ) : (
            <>
              If we recognize the email you provided, you'll receive a link shortly — either a sign-in link or, if you're still on the waitlist, a status link. Either way, it expires in 15 minutes.
            </>
          )}
        </p>
        <p className="below-card">
          Wrong email? <Link to="/sign-in">Send to a different address</Link>
        </p>
      </div>
    </AuthShell>
  );
}
